module.exports = __webpack_public_path__ + "media/images/ringrevenue/multi_checkbox-45997e6acaa211b39407e7c4ec6bfae7.gif";